import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import lock from "../../images/lock.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function RecoveryAccount() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [validated, setValidated] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <Header />
            <Container fluid className='bg-sky min-vh-custom'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={lock} width={50} />
                                <h3 className='text-center mt-3'>{t('login.recover_title')}</h3>

                                <Row className='justify-content-center text-center'>
                                    <Col md={5} className='text-start bg-white p-3 rounded-4 my-4 ps-4'>
                                        <Form noValidate validated={validated}>
                                            <Row className="mb-3 row">
                                                <Col md={6}>
                                                    <label className="form-label mt-2">{t('login.email_phone')}</label>
                                                    <input type="email" className="form-control rounded-5 py-3 mt-2" placeholder='youremail@email.com' />
                                                </Col>
                                                <Col md={6}>
                                                    <label htmlFor="password" className="form-label mt-2">{t('common.password')}</label>
                                                    <div className='input-group'>
                                                        <input
                                                            type={showPassword ? 'text' : 'password'}
                                                            className="form-control rounded-5 py-3 mt-2"
                                                            placeholder={t('login.type_password')}
                                                            id="password"
                                                        />
                                                        <span
                                                            className="input-group-text bg-transparent border-0 icon"
                                                            onClick={handleTogglePassword}
                                                        >
                                                            <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className='justify-content-center'>
                                                <Col md={6}>
                                                    <Row className='m-0 d-flex align-items-center py-4 text-center'>
                                                        <Button type="submit" variant='' className="btn rounded-5 border-0 text-white" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('login.recover_btn')}</Button>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default RecoveryAccount;
